/* Sierra Vitalis — product page enhancements */

(function () {
  'use strict';

  /* ── Sticky Add-to-Cart bar ──────────────────────────────────────────── */
  function initStickyAtc() {
    var bar = document.querySelector('.sv-sticky-atc');
    if (!bar) return;

    // Wire up the sticky button → triggers the main form's submit button
    var stickyBtn = bar.querySelector('.sv-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var targetId = this.dataset.mainBtnId;
        var mainBtn = targetId ? document.getElementById(targetId) : null;
        if (mainBtn && !mainBtn.disabled) {
          mainBtn.click();
        }
      });
    }

    var isDesktop = window.matchMedia('(min-width: 990px)');
    var visible = false;
    var rafPending = false;

    function show() {
      if (visible) return;
      visible = true;
      bar.classList.add('is-visible');
      bar.removeAttribute('aria-hidden');
    }

    function hide() {
      if (!visible) return;
      visible = false;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    function evaluate() {
      rafPending = false;
      if (!isDesktop.matches) {
        hide();
        return;
      }
      if (window.scrollY > 600) {
        show();
      } else {
        hide();
      }
    }

    function onScroll() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(evaluate);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    isDesktop.addEventListener('change', evaluate);

    // Run the initial check after layout has settled
    requestAnimationFrame(evaluate);
  }

  /* ── Boot ────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyAtc();
    });
  } else {
    initStickyAtc();
  }
})();
